module.exports = __webpack_public_path__ + "img/menu6.0cd0358b.png";